(function (Drupal, drupalSettings) {
  Drupal.behaviors.leafletHome = {
    attach: function (context, settings) {
      const mapElement = context.querySelector(".pole_1 #map");
      if (mapElement && !mapElement.dataset.leafletHomeProcessed) {
        mapElement.dataset.leafletHomeProcessed = "true";

        const planes = [
          [
            "<strong>Hôpital de La Louvière - Site Jolimont</strong>Rue Ferrer 159<br>7100 La Louvière<br><a href='tel:064 23 30 11' class='tel'>064 23 30 11</a>",
            50.477487,
            4.215566,
          ],
          [
            "<strong>Hôpital de Lobbes</strong>Rue de la Station 25<br>6540 Lobbes<br><a href='tel:071 59 92 11' class='tel'>071 59 92 11</a>",
            50.345993,
            4.259955,
          ],
          [
            "<strong>Hôpital de Tubize</strong>Avenue de Scandiano 8<br>1480 Tubize<br><a href='tel:02 391 01 30' class='tel'>02 391 01 30</a>",
            50.693283,
            4.203352,
          ],
          [
            "<strong>Hôpital de Nivelles</strong>Rue Samiette 1<br>1400 Nivelles<br><a href='tel:067 88 52 11' class='tel'>067 88 52 11</a>",
            50.595593,
            4.317761,
          ],
          [
            "<strong>Hôpital de Mons - Site Constantinople</strong>Avenue Baudouin de Constantinople 5<br>7000 Mons<br><a href='tel:065 38 55 11' class='tel'>065 38 55 11</a>",
            50.454575,
            3.96012,
          ],
          [
            "<strong>Hôpital de Warquignies</strong>Rue des Chaufours 27<br>7300 Boussu<br><a href='tel:065 38 55 11' class='tel'>065 38 55 11</a>",
            50.417568,
            3.806986,
          ],
          [
            "<strong>Hôpital de Mons - Site Kennedy</strong>Boulevard Kennedy 2<br>7000 Mons<br><a href='tel:065 41 41 41' class='tel'>065 41 41 41</a>",
            50.457575131764905,
            3.9630691623554632,
          ],
        ];

        const map = L.map(mapElement).setView([50.5, 3.8], 10);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors',
          maxZoom: 18,
        }).addTo(map);

        const jolimontIcon = L.icon({
          iconUrl:
            "/themes/custom/expansion/assets/dist/images/jolimont-map-icon.png",
          iconSize: [64, 64],
          iconAnchor: [32, 32],
          popupAnchor: [0, -30],
        });

        const markerArray = planes.map(([popupText, lat, lng]) => {
          return L.marker([lat, lng], { icon: jolimontIcon })
            .bindPopup(popupText, { minWidth: "250" })
            .addTo(map);
        });

        const group = L.featureGroup(markerArray);
        map.fitBounds(group.getBounds());
      }
    },
  };
})(Drupal, drupalSettings);
